import {
  BooleanField,
  EmailField,
  SimpleShowLayout,
  TextField,
  // ReferenceField,
  // FunctionField,
  // ReferenceArrayField,
  // ChipField,
  // SingleFieldList,
  // useTranslate,
  // useLocaleState,
  // useRecordContext,
} from 'react-admin'

import { Grid, Box } from '@mui/material'

import { ShowBase } from '../../components/base'
import { DateField, NameField } from '../../components/fields'
import { AvatarField } from '../../components/fields/AvatarField'
import { ADMINS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'

export const AdminShow = (): JSX.Element => {
  // const translate = useTranslate()
  // const [locale] = useLocaleState()

  // const BranchesField = (): JSX.Element => {
  //   const record = useRecordContext()
  //   if (record.access_level == 's') {
  //     return (
  //       <Grid item xs={12}>
  //         <SimpleShowLayout>
  //           <ReferenceArrayField
  //             source='access_branches'
  //             reference='branches'
  //             label={`${ADMINS_FIELDS}.property`}
  //           >
  //             <SingleFieldList>
  //               <ChipField source={`name_${locale}`} />
  //             </SingleFieldList>
  //           </ReferenceArrayField>
  //         </SimpleShowLayout>
  //       </Grid>
  //     )
  //   } else {
  //     return null
  //   }
  // }

  return (
    <ShowBase
      title='resources.admins.show.title'
      listAction={{
        hasBackButton: true,
      }}
    >
      <SimpleShowLayout>
        <Grid container justifyContent='center'>
          <Grid container item xs={12} sm={8} md={6}>
            <Grid item xs={12}>
              <Box
                sx={{
                  alignItems: 'center',
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <AvatarField source='avatar.full_path' sx={{ width: 150, height: 150 }} />
                <NameField
                  firstNameSource='firstname_th'
                  lastNameSource='lastname_th'
                  source='firstname_th'
                  sx={{ fontSize: 24 }}
                  label={`${ADMINS_FIELDS}.name`}
                />
              </Box>
            </Grid>
            <Grid item xs={6}>
              <SimpleShowLayout>
                <TextField source='user_id' label={`${ADMINS_FIELDS}.user_id`} />
              </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
              <SimpleShowLayout>
                <EmailField source='email' label={`${ADMINS_FIELDS}.email`} />
              </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
              <SimpleShowLayout>
                <TextField source='role.name' label={`${ADMINS_FIELDS}.role`} />
              </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
              <SimpleShowLayout>
                <BooleanField source='is_active' label={`${COMMON_FIELDS}.status.label`} />
              </SimpleShowLayout>
            </Grid>
            {/* <Grid item xs={6}>
              <SimpleShowLayout>
                <FunctionField
                  label={`${ADMINS_FIELDS}.access_level.label`}
                  render={(record): string => {
                    return record.access_level == 'a'
                      ? translate(`${ADMINS_FIELDS}.access_level.choices.all_branches`)
                      : translate(`${ADMINS_FIELDS}.access_level.choices.some_branches`)
                  }}
                />
              </SimpleShowLayout>
            </Grid> */}
            {/* <BranchesField /> */}

            <Grid item xs={6}>
              <SimpleShowLayout>
                <DateField source='last_login' label={`${ADMINS_FIELDS}.last_login`} />
              </SimpleShowLayout>
            </Grid>
            <Grid item xs={6}>
              <SimpleShowLayout>
                <DateField source='create_at' label={`${ADMINS_FIELDS}.create_at`} />
              </SimpleShowLayout>
            </Grid>
            {/* <Grid item xs={6}>
              <SimpleShowLayout>
                <ReferenceField
                  source='create_by'
                  reference='admins'
                  label={`${ADMINS_FIELDS}.create_by`}
                >
                  <NameField
                    firstNameSource='firstname_th'
                    lastNameSource='lastname_th'
                    source='firstname_th'
                  />
                </ReferenceField>
              </SimpleShowLayout>
            </Grid> */}
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </ShowBase>
  )
}

export default AdminShow
